import { Grid } from '@mui/material'
import { useRouter } from 'next/router';
import Dynamic100Vh from '../../../components/DynamicDiv100vh/Div100Vh';
import TopBar from '../../../components/TopBar/TopBar';


const TermsOfUse = () => {
    const router = useRouter();

    const handleGoBackClick = () => {
        router.back();
    }
    return (
        <Dynamic100Vh style={{ width: "100%" }}>
            <Grid container direction={"column"} height={"100%"}>
                <Grid item height={"70px"}>
                    <TopBar pageName='Terms of Use'>
                        <title>TRYO - Terms of Use</title>
                    </TopBar>
                </Grid>
                <Grid item height={"calc(100% - 70px)"} p={1}>
                    <iframe frameBorder="0" height={"100%"} width={"100%"} src={"https://master.dw6wgf31l0ads.amplifyapp.com/pages/terms-of-use.html"} title={"Terms Of Use"}></iframe>
                </Grid>
            </Grid>
        </Dynamic100Vh>
    )
}

export default TermsOfUse